export enum DateRange {
  day0 = "day0",
  day1 = "day1",
  week0 = "week0",
  week1 = "week1",
  month0 = "month0",
  month1 = "month1",
  custom = "custom",
}

export enum ResponseCode {
  Success = 0,
  NoAuthorizationHeader = 1,
  InvalidAuthorizationHeader = 2,
  InvalidAccessToken = 3,
  InvalidUser = 4,
  PermissionDenied = 5,
  RedirectRequestToExternalService = 6,
  RedirectRequestToInternalService = 7,
  WrongDatabaseTransaction = 8,
  UnknownError = 9,
  SignatureError = 10,
  WrongUsername = 11,
  WrongPassword = 12,
  TokenCreationFailure = 13,
  AccessDenied = 21,
  TransactionInvalid = 31,
  TransactionAmountInvalid = 32,
  SystemWithdrawAmountNotInLimitRange = 100,
  SystemDepositAmountNotInLimitRange = 101,
  ProviderWithdrawAmountNotInLimitRange = 110,
  ProviderDepositAmountNotInLimitRange = 111,
  OperatorWithdrawAmountNotInLimitRange = 120,
  OperatorDepositAmountNotInLimitRange = 121,
  TenantWithdrawAmountNotInLimitRange = 130,
  TenantDepositAmountNotInLimitRange = 131,
  MemberWithdrawAmountNotInLimitRange = 140,
  MemberDepositAmountNotInLimitRange = 141,
  MemberWithdrawAmountAndAmount0CanNotBeNegativeNumber = 142,
  MemberDepositAmountAndAmount0CanNotBeNegativeNumber = 143,
  MemberWithdrawAmountNotFitAmount0 = 144,
  MemberDepositAmountNotFitAmount0 = 145,
  MissingWallet = 200,
  MissingWalletSystemCollect = 201,
  MissingWalletSystemReceive = 202,
  MissingWalletProviderCollect = 210,
  MissingWalletProviderReceive = 211,
  MissingWalletOperatorCollect = 220,
  MissingWalletOperatorReceive = 221,
  MissingWalletOperatorRentEnergy = 222,
  MissingWalletTenantCollect = 230,
  MissingWalletTenantReceive = 231,
  MissingTransfer = 301,
  InvalidTransfer = 302,
  MissingTransferUser = 303,
  NotEnoughWalletBalance = 401,
  NotEnoughOperatorBalance = 402,
  NotInTestMode = 999,
}

export const responseCodeToI18nKey: Record<ResponseCode, string> = {
  [ResponseCode.Success]: "success",
  [ResponseCode.NoAuthorizationHeader]: "noAuthorizationHeader",
  [ResponseCode.InvalidAuthorizationHeader]: "invalidAuthorizationHeader",
  [ResponseCode.InvalidAccessToken]: "invalidAccessToken",
  [ResponseCode.InvalidUser]: "invalidUser",
  [ResponseCode.PermissionDenied]: "permissionDenied",
  [ResponseCode.RedirectRequestToExternalService]:
    "redirectRequestToExternalService",
  [ResponseCode.RedirectRequestToInternalService]:
    "redirectRequestToInternalService",
  [ResponseCode.WrongDatabaseTransaction]: "wrongDatabaseTransaction",
  [ResponseCode.UnknownError]: "unknownError",
  [ResponseCode.SignatureError]: "signatureError",
  [ResponseCode.WrongUsername]: "wrongUsername",
  [ResponseCode.WrongPassword]: "wrongPassword",
  [ResponseCode.TokenCreationFailure]: "tokenCreationFailure",
  [ResponseCode.AccessDenied]: "accessDenied",
  [ResponseCode.TransactionInvalid]: "transactionInvalid",
  [ResponseCode.TransactionAmountInvalid]: "transactionAmountInvalid",
  [ResponseCode.SystemWithdrawAmountNotInLimitRange]:
    "systemWithdrawAmountNotInLimitRange",
  [ResponseCode.SystemDepositAmountNotInLimitRange]:
    "systemDepositAmountNotInLimitRange",
  [ResponseCode.ProviderWithdrawAmountNotInLimitRange]:
    "providerWithdrawAmountNotInLimitRange",
  [ResponseCode.ProviderDepositAmountNotInLimitRange]:
    "providerDepositAmountNotInLimitRange",
  [ResponseCode.OperatorWithdrawAmountNotInLimitRange]:
    "operatorWithdrawAmountNotInLimitRange",
  [ResponseCode.OperatorDepositAmountNotInLimitRange]:
    "operatorDepositAmountNotInLimitRange",
  [ResponseCode.TenantWithdrawAmountNotInLimitRange]:
    "tenantWithdrawAmountNotInLimitRange",
  [ResponseCode.TenantDepositAmountNotInLimitRange]:
    "tenantDepositAmountNotInLimitRange",
  [ResponseCode.MemberWithdrawAmountNotInLimitRange]:
    "memberWithdrawAmountNotInLimitRange",
  [ResponseCode.MemberDepositAmountNotInLimitRange]:
    "memberDepositAmountNotInLimitRange",
  [ResponseCode.MemberWithdrawAmountAndAmount0CanNotBeNegativeNumber]:
    "memberWithdrawAmountAndAmount0CanNotBeNegativeNumber",
  [ResponseCode.MemberDepositAmountAndAmount0CanNotBeNegativeNumber]:
    "memberDepositAmountAndAmount0CanNotBeNegativeNumber",
  [ResponseCode.MemberWithdrawAmountNotFitAmount0]:
    "memberWithdrawAmountNotFitAmount0",
  [ResponseCode.MemberDepositAmountNotFitAmount0]:
    "memberDepositAmountNotFitAmount0",
  [ResponseCode.MissingWallet]: "missingWallet",
  [ResponseCode.MissingWalletSystemCollect]: "missingWalletSystemCollect",
  [ResponseCode.MissingWalletSystemReceive]: "missingWalletSystemReceive",
  [ResponseCode.MissingWalletProviderCollect]: "missingWalletProviderCollect",
  [ResponseCode.MissingWalletProviderReceive]: "missingWalletProviderReceive",
  [ResponseCode.MissingWalletOperatorCollect]: "missingWalletOperatorCollect",
  [ResponseCode.MissingWalletOperatorReceive]: "missingWalletOperatorReceive",
  [ResponseCode.MissingWalletOperatorRentEnergy]:
    "missingWalletOperatorRentEnergy",
  [ResponseCode.MissingWalletTenantCollect]: "missingWalletTenantCollect",
  [ResponseCode.MissingWalletTenantReceive]: "missingWalletTenantReceive",
  [ResponseCode.MissingTransfer]: "missingTransfer",
  [ResponseCode.InvalidTransfer]: "invalidTransfer",
  [ResponseCode.MissingTransferUser]: "missingTransferUser",
  [ResponseCode.NotEnoughWalletBalance]: "notEnoughWalletBalance",
  [ResponseCode.NotEnoughOperatorBalance]: "notEnoughOperatorBalance",
  [ResponseCode.NotInTestMode]: "notInTestMode",
};
